import moment from 'moment-timezone'
import Decimal from 'decimal.js'

export default {
  methods: {
    sharedMethod() {
      console.log('I am a shared methodหก')
    },
    FormateDateTh(val) {
      if (val) {
        const formattedDate = moment(val, 'YYYY-MM-DD')
          .locale('th') // Set the locale to Thai
          .format('DD MMMM YYYY')
        return formattedDate
      }
      return ''
    },
    Commas(x) {
      if (!x) {
        return 0
      }
      if (x % 1 !== 0) {
        const d = new Decimal(x)
        // return Number(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        const rounded = d.toDecimalPlaces(2, Decimal.ROUND_DOWN)
        // let roundedNumber = Math.round(x * 100) / 100;
        return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    CommasCue(x) {
      if (!x) {
        return 0
      }
      const d = new Decimal(x)
      const rounded = d.toDecimalPlaces(6, Decimal.ROUND_DOWN)
      return rounded.toNumber()
    },
    CommasUp(x) {
      if (!x) {
        return 0
      }
      const d = new Decimal(x)
      const roundedDown = d.toDecimalPlaces(2, Decimal.ROUND_DOWN)
      // const roundedDownNumber = Math.floor(x * 100) / 100
      return roundedDown.toNumber()
    },
  },
}
